import { Button, Form, Header, SpaceBetween } from '@amzn/awsui-components-react-v3';
import React, { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';
import ExceptionForm from '../ExceptionForm';
import { useExceptionForm } from '../ExceptionForm/useExceptionForm';
import { useRouteLoadDurationPublisher } from '@awsscm/argo-core/argo/utils/metrics/ArgoRouteLoadDurationContext';

export default function CreateExceptionForm(): ReactElement {
  const publishRouteLoadDuration = useRouteLoadDurationPublisher();
  const { t } = useTranslation();
  const { form, assignedToGroups } = useExceptionForm();
  publishRouteLoadDuration();
  return (
    <div className="small-form-max-width">
      <Form
        actions={
          <SpaceBetween direction="horizontal" size="xs">
            <Button
              data-test-id="reset"
              disabled={form.isSubmitting}
              variant="link"
              onClick={() => form.resetForm()}>
              {t('Reset')}
            </Button>
            <Button
              data-test-id="submit"
              loading={form.isSubmitting || form.isValidating}
              variant="primary"
              onClick={() => form.handleSubmit()}>
              {t('Create exception')}
            </Button>
          </SpaceBetween>
        }
        header={
          <>
            <Header
              variant="h1"
              description={t(
                'Create Receiving exception so they can be searched, edited, and resolved. Fill out as much information as possible.'
              )}>
              {t('Create a Receiving Exception')}
            </Header>
          </>
        }>
        <ExceptionForm isEditForm={false} form={form} assignedToGroups={assignedToGroups} />
      </Form>
    </div>
  );
}
